import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime, filter } from 'rxjs/operators';
import { Pagination } from '../../../core/shared/classes/pagination';
import { Article } from '../../../facturation/shared/classes/article';
import { ArticleService } from '../../../facturation/shared/services/article.service';
import { AlertService } from '../../services/alert.service';

@Component({
  selector: 'app-select-article',
  templateUrl: './select-article.component.html',
  styleUrls: ['./select-article.component.css']
})
export class SelectArticleComponent implements OnInit {

  article: Article = null;
  tauxNormalTva: number = null;
  @Output() onSelectArticle: EventEmitter<Article> = new EventEmitter();

  listArticles: Article[] = [];
  displayedColumns = ['art_code', 'art_libelle', 'art_prix_unitaire_ht', 'art_taux_tva'];
  pagination: Pagination = new Pagination();
  public  currentPage = 1;
  public  maxItemPerPage = 50;
  public  pageSizeOption = [5, 10, 25, 50, 100];

  searchTerm: FormControl = new FormControl();

  constructor(
    protected articleService: ArticleService,
    protected alertService: AlertService
  ) { }

  ngOnInit() {
    this.fetchArticles();
    this.initSearchArticle();
  }

  initSearchArticle() {
    this.searchTerm.valueChanges
    .pipe(
        debounceTime(400),
        filter((value: string) => !value || (value && value.length > 1)) //Reload on nothing or on something with at least 2 chars
    )
    .subscribe(searchTerm => {
        const params = {currentPage: 1, maxItemPerPage: this.maxItemPerPage, searchTerm: searchTerm};
        this.fetchArticles(params);
    });
}

  fetchArticles(params?: {currentPage: number, maxItemPerPage: number, searchTerm?: string}) {
    this.articleService.getList(params).subscribe(response => {
      if (response && response.status === 200) {
        this.listArticles = [];
        this.pagination = new Pagination(response.data.pagination);
        response.data.data.map((article: Article) => {
          this.listArticles.push(new Article(article));
        });
      } else {
        this.alertService.error(response.message);
      }
    });
  }

  onPageChange($event) {
    if ($event.pageSize !== this.maxItemPerPage) {
      this.maxItemPerPage = $event.pageSize;
    } else if (($event.pageIndex + 1) !== this.currentPage) {
      this.currentPage = ($event.pageIndex + 1);
    }

    this.fetchArticles({currentPage: this.currentPage, maxItemPerPage: this.maxItemPerPage});
  }

  onClickArticle(article: Article) {
    this.onSelectArticle.emit(article);
  }
}
